<template>
  <div class="portfolioImage">
    <img :src="src" alt="">
  </div>
</template>

<script>
  export default {
    name: 'portfolio-image',
    props: {
      src: String,
    },
  }
</script>

<style scoped lang="scss">
  .portfolioImage {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    overflow: hidden;
    max-height: 370px;
    height: 100%;
    width: 280px;
    padding: 0 10px;
    img {
      max-width: 100%;
    }
  }
</style>
